const ROUTES = {
  HOME: {
    TITLE: "Home",
    LINK: "/",
  },
  DASHBOARD: {
    TITLE: "Dashboard",
    LINK: "/dashboard",
  },
  ACCOUNT: {
    LINK: "/",
  },
  CATALOG: {
    LINK: "/catalog",
    TITLE: "Products Catalog",
  },
  ORDERS: {
    LINK: "/orders",
    TITLE: "Orders",
  },
  ORDER_DETAILS: {
    LINK: "/order-details",
  },
  MY_STORES: { LINK: "/my-stores", TITLE: "My Stores" },
  MY_STORES_PRODUCTS: { LINK: "/my-stores/products" },
  MY_STORES_SYNC_PRODUCTS: {
    LINK: "/my-stores/sync-products",
    TITLE: "Sync Products",
  },
  MY_STORES_SYNC_PRODUCT: {
    LINK: "/sync-product",
    TITLE: "Sync Product",
  },
  MY_STORES_SHIPPING: { LINK: "/my-stores/shipping" },
  MY_STORES_REGISTRATION: {
    LINK: "/my-stores/registration",
    TITLE: "Add Store",
  },
  CONNECT_TO_SHOPIFY: { LINK: "/connect-to-shopify" },
  BROWSE_CATALOG: { TITLE: "Browse", LINK: "/catalog/browse" },
  PRODUCT_DETAIL: { LINK: "/product-detail", TITLE: "Product Detail" },
  ACCOUNT_SETTINGS: { LINK: "/account-settings" },
  ADMIN_USERS: { LINK: "/admin/users" },
  ADMIN_SETTINGS: { LINK: "/admin/settings" },
  ADMIN_DTG_PLUS: { LINK: "/admin/dtg-plus", TITLE: "DTG Plus" },
  ADMIN_SALES_REPORT: { LINK: "/admin/sales-report", TITLE: "Sales Report" },
  USER_SALES_REPORT: { LINK: "/user/sales-report", TITLE: "Sales Report" },
  ADMIN_CREATE_PRODUCT: { LINK: "/admin/create-product" },
  ADMIN_EDIT_PRODUCT: { LINK: "/admin/edit-product" },
  WAREHOUSE: { LINK: "/warehouse", TITLE: "Warehouse" },
  GROUPS: { LINK: "/groups", TITLE: "Groups" },
  INVENTORY: { LINK: "/inventory", TITLE: "Inventory" },
  ORDER_STOCK: { LINK: "/order-stock", TITLE: "Order Stock" },
  SUBMITTED_ORDER_STOCK: {
    LINK: "/submitted-order-stock",
    TITLE: "Submitted Order Stock",
  },
  // PRINTIFY_INVOICES: {
  //   LINK: "/printify-invoices",
  //   TITLE: "Printify Invoices",
  // },
  ZAZZLE_INVOICES: {
    LINK: "/zazzle-invoices",
    TITLE: "Zazzle Invoices",
  },
  // PRINTIFY_ORDERS: {
  //   LINK: "/printify-orders",
  //   TITLE: "Printify Orders Events",
  // },
  I_PROMOTE_U: { LINK: "/ipromoteu" },
  STAPLES_BULK_ORDERS: {
    LINK: "/staples-bulk-orders",
    TITLE: "Staples Bulk Orders",
  },

  PARTN_BRIGHAM: {
    LINK: "/partn-brigham-and-womens-hosp-program",
    TITLE: "Staples Program",
  },

  STAPLES_ART_FILES: {
    LINK: "/staples-art-files",
    TITLE: "Staples Art Files",
  },
  FULFILLMENT_DAYS: {
    LINK: "/fulfillment-days",
    TITLE: "Fulfillment Days",
  },
  CONNECT_TO_WOO_COMMERCE: { LINK: "/connect-to-woo-commerce" },
  NEWS_ROOM: {
    LINK: "/news-room",
    TITLE: "News Room",
  },
  // SMART_PRINT_SINK: {
  //   LINK: "/smartprintsink",
  //   TITLE: "SMART PRINT SINK",
  // },

  WAMI_SWAG: {
    LINK: "/wami-swag",
    TITLE: "WAMI SWAG",
  },

  BLINK_SWAG: {
    LINK: "/blink-swag",
    TITLE: "BLINK SWAG",
  },
  BRIKL: {
    LINK: "/brikl",
    TITLE: "BRIKL",
  },

  ORBIT_KIT: {
    LINK: "/orbitkit",
    TITLE: "ORBITKIT",
  },
  PROFORMA: {
    LINK: "/proforma",
    TITLE: "PROFORMA",
  },

  COTTON_CANDY: {
    LINK: "/cotton-candy",
    TITLE: "Cotton Candy",
  },

  ADMIN_SCREEN_PRINTING: {
    LINK: "/admin/screen-printing",
    TITLE: "Screen Printing",
  },

  // FAST_PLATFORM: {
  //   LINK: '/fast-platform',
  //   TITLE: 'FAST PLATFORM',
  // },

  PRINT_YOUR_CAUSE: {
    LINK: "/printyourcause",
    TITLE: "PRINT YOUR CAUSE",
  },

  IMS_RETAIL: {
    LINK: "/ims-retail",
    TITLE: "IMS RETAIL",
  },

  // AMERICAN_DIVERSITY: {
  //   LINK: "/american-diversity",
  //   TITLE: "AMERICAN DIVERSITY",
  // },

  AMERICAN_BUSINESS: {
    LINK: "/american-business",
    TITLE: "AMERICAN BUSINESS",
  },

  WEB_PAGES: {
    LINK: "/web-pages",
    TITLE: "Web Pages",
  },
};

export { ROUTES };
